module.exports = __webpack_public_path__ + "img/便民网点.379d6e0d.png";